import * as Handlebars from 'handlebars';

const defaultHelpers = [
  {
    name: 'ifEquals',
    function: `function(arg1, arg2, options) {return (arg1 === arg2) ? options.fn(this) : options.inverse(this);}`
  },
  {
    name: 'ifNotEquals',
    function: `function(arg1, arg2, options) {return (arg1 !== arg2) ? options.fn(this) : options.inverse(this);}`
  },
  {
    name: 'switch',
    function: `function(value, options) {let obj = {}; obj.switch_value = value;obj.switch_break = false; return options.fn(obj);}`
  },
  {
    name: 'case',
    function: `function(value, options) {if (value === this.switch_value) {this.switch_break = true;return options.fn(this);}}`
  },
  {
    name: 'default',
    function: `function(value, options) {if (this.switch_break === false) {return value;}}`
  },
  {
    name: 'dateFormat',
    function: `function(date, format, options) { return moment(date).format(format); }`
  },
  {
    name: 'dateAdd',
    function: `function(date, amount, what, options) { return moment(date).add(amount, what).format(); }`
  },
  {
    name: 'dateFromNow',
    function: `function(date, options) { return moment(date).fromNow(); }`
  },
  {
    name: 'dateToNow',
    function: `function(date, options) { return moment(date).toNow(); }`
  },
  {
    name: 'dateCalendar',
    function: `function(date, options) { return moment(date).calendar(); }`
  }
];

const sclHandlebars = (() => {
    return{
        initHandlebars(helpers) {
            /*
            // Adding some standard helpers
            // Comparison
            Handlebars.registerHelper('ifEquals', function(arg1, arg2, options) {
                return (arg1 === arg2) ? options.fn(this) : options.inverse(this);
            });
            Handlebars.registerHelper('ifNotEquals', function(arg1, arg2, options) {
                return (arg1 !== arg2) ? options.fn(this) : options.inverse(this);
            });
            Handlebars.registerHelper('switch', function(value, options) {
                let that: any = {};
                that.switch_value = value;
                that.switch_break = false;
                return options.fn(that);
            });
            Handlebars.registerHelper('case', function(value, options) {
            if (value === this.switch_value) {
                this.switch_break = true;
                return options.fn(this);
            }
            });
            Handlebars.registerHelper('default', function(value, options) {
            if (this.switch_break === false) {
                return value;
            }
            });
            // Date handling
            Handlebars.registerHelper('dateFormat', function(date, format, options) { return moment(date).format(format); });
            Handlebars.registerHelper('dateAdd', function(date, amount, what, options) { return moment(date).add(amount, what).format(); });
            Handlebars.registerHelper('dateFromNow', function(date, options) { return moment(date).fromNow(); });
            Handlebars.registerHelper('dateToNow', function(date, options) { return moment(date).toNow(); });
            Handlebars.registerHelper('dateCalendar', function(date, options) { return moment(date).calendar(); }); */

            for (let i = 0; i < defaultHelpers.length; i++) {
              if (typeof defaultHelpers[i].name === 'string' && typeof defaultHelpers[i].function === 'string') {
                // tslint:disable-next-line:prefer-const
                let defaultHelps;
                // tslint:disable-next-line:no-eval
                eval('defaultHelps = ' + defaultHelpers[i].function);
                Handlebars.registerHelper(defaultHelpers[i].name, defaultHelps);
              }
            }

            // If component has helpers defined add them in too
            if (typeof helpers !== 'undefined' && helpers !== null ) {
                for (let i = 0; i < helpers.length ; i++) {
                    if (typeof helpers[i].name === 'string' && typeof helpers[i].function === 'string') {
                      // tslint:disable-next-line:prefer-const
                        let helpFunc;
                      // tslint:disable-next-line:no-eval
                        eval('helpFunc = ' + helpers[i].function);
                        Handlebars.registerHelper(helpers[i].name, helpFunc);
                    }
                }
            }
        },

        defaultHelpers() {
          return defaultHelpers;
        },
        checkRegistedHelpers(helpers) {
            if (!helpers) { return; }
            // console.log('%c ibefore checkRegistedHelpers : ', 'color:blue');
            // console.log(Handlebars.helpers);
            let isRegistered = true;
            for (let i = 0; i < helpers.length ; i++) {
                if (typeof helpers[i].name === 'string' && typeof helpers[i].function === 'string') {
                    if (!(helpers[i].name in Handlebars.helpers)) {
                        isRegistered = false;
                        break;
                    }
                }
            }
            if (!isRegistered) {
                sclHandlebars.initHandlebars(helpers);
            }
        },
        // throws an error instead of returning null
        processHandlebarsV2(handlebarsString, data, handlebarsContext?: any, helpers?) {
            sclHandlebars.checkRegistedHelpers(helpers);
            if (handlebarsString == null) { return ''; }
            let hStr;
            if (typeof handlebarsString === 'string') {
                hStr = handlebarsString;
            } else {
                hStr = JSON.stringify(handlebarsString);
            }

            // begin : 14274
            if (!handlebarsContext) {
              handlebarsContext = {};
            }
            const invalidField = ['document', 'doc', 'account', 'tpl', 'componentDefinition'
            , 'results', 'resultsCount', 'resultsIndex', 'result', 'row'];
            if (data) {
                if (Object(data) === data) {// if the second parameter is object has property
                    for (const f in data) {
                        if (f === 'queryResultDocument') {
                            handlebarsContext.row = data[f];
                            handlebarsContext.result = data[f];
                            for (const j in data[f]) {
                                if (data[f].hasOwnProperty(j)) {
                                    if (invalidField.indexOf(j) > -1) {
                                        console.log('Handlebars Context Error: the field ' + j
                                        + ' is already present in document documentId so could not be set.'
                                        + ' It\'s values will NOT be available to handlebars expressions.'
                                        + ' Please advise your Application Developer to not use this field name if possible');
                                        continue;
                                    }
                                    handlebarsContext[j] = data[f][j];
                                }
                            }

                        } else {
                            if (handlebarsContext.hasOwnProperty(f)) {
                                console.log('error : handlebarsString = ' + handlebarsString
                                + '\n\t data = ' + JSON.stringify(data)
                                + '\n\t handlebarsContext = ' + JSON.stringify(handlebarsContext)
                                + '\n\t helpers = ' + JSON.stringify(helpers));
                                // console.log('Handlebars Context Error: the field ' + f
                                //  + ' is already present in document documentId so could not be set.'
                                //  + ' It\'s values will NOT be available to handlebars expressions.'
                                //  + ' Please advise your Application Developer to not use this field name if possible');
                                continue;
                            }
                            handlebarsContext[f] = data[f];
                        }
                    }
                } else {
                    console.log('Handlebars Context Error: object ' + data + ' wasn\'t passed in and the parameters is being ignored');
                }
            }
            // end : 14274
            // console.log('handlebarsContext = ' + JSON.stringify(handlebarsContext));
            let result = null;
            try {
                const template = Handlebars.compile(hStr);
                result = template(handlebarsContext);
            } catch (err) {
                err.hStr = hStr;
                throw err;
            }

            return result;
        },
        // backward compatibility purposes because it's still used in a lot of areas: returns an null object
        processHandlebars(handlebarsString, data, handlebarsContext?: any, helpers?) {
          let result = null;
          try {
            result = sclHandlebars.processHandlebarsV2(handlebarsString, data, handlebarsContext, helpers);
          } catch (err) {
            console.error(err);
          }
          return result;
        },
        processIntHandlebars(handlebarsString, data, helpers) {
            const hStr = sclHandlebars.processHandlebars(handlebarsString, data, helpers);
            if (hStr) {
                return parseInt( hStr, 0 );
            } else { return 0; }
        },
        processFloatHandlebars(handlebarsString, data, helpers) {
            const hStr = sclHandlebars.processHandlebars(handlebarsString, data, helpers);
            if (hStr) {
                return parseFloat( hStr );
            } else { return 0; }
        },
        processBooleanHandlebars(handlebarsString, data, helpers) {
            return  sclHandlebars.processHandlebars(handlebarsString, data, helpers) === 'true';
        },
        processArrayHandlebars(handlebarsString, data, helpers) {
            const hStr = sclHandlebars.processHandlebars(handlebarsString, data, helpers);
            if (hStr) {
                try {
                    const obj = JSON.parse( hStr );
                    const arr = [];
                    for (const i in obj) {
                        if (obj.hasOwnProperty(i)) {
                            arr.push(obj[i]);
                        }
                    }
                    return arr;
                } catch (err) {
                    return null;
                }
            } else {
                return null;
            }
        }
    };
})();

export { sclHandlebars };
